import { SurveyMenuPage } from './../survey-menu/survey-menu';
import { Component, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import { IonicPage, NavController, NavParams, Loading, LoadingController } from 'ionic-angular';
import { AlertController, ToastController, PopoverController, Slides } from 'ionic-angular';
import { Survey, SurveyQuestion, SurveyDemographicAnswerData, SurveyAnswerData } from '../../model/SurveyModel';
import { Subscription } from 'rxjs/Subscription';
import { AppStore } from '../../store/AppStore';
import { Store } from '@ngrx/store';
import { SurveySaveAnswerAction, SurveySaveDemographicAnswerAction } from '../../store/action/SurveyActions';

import { SurveyService } from '../../services/SurveyService';

import _ from 'lodash';

@IonicPage()
@Component({
  selector: 'page-survey-accomplish',
  templateUrl: 'survey-accomplish.html',
  providers: [DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SurveyAccomplishPage {

  @ViewChild(Slides) slides: Slides;

  public selectedItem: Survey;
  public selectedType: string;
  public demographicQuestions: Array<SurveyQuestion> = null;
  public surveyQuestions: Array<SurveyQuestion> = [];
  public currentPage: number;
  public totalPages: number;
  public paginationVisible: boolean;
  public paginationPreviousVisible: boolean;
  public paginationNextVisible: boolean;
  public isLoading: boolean;
  public loader: Loading;

  private userSubscription: Subscription;
  private surveySubscription: Subscription;

  private userId: number;
  private swipeNext: boolean;
  private finish: boolean;
  private navigationDone: boolean;
  private saveDiscursiveAnswer: SurveyQuestion;

  private showRealize: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    private store: Store<AppStore>,
    private cd: ChangeDetectorRef,
    private popoverCtrl: PopoverController,
    private datePipe: DatePipe,
    private surveyService: SurveyService
  ) {
    this.isLoading = false;
    this.selectedItem = this.navParams.get('item');
    this.selectedType = this.navParams.get('type');
    this.sortAnswers();
    this.paginationVisible = false;
    this.swipeNext = false;
    this.finish = false;
    this.navigationDone = false;
    this.saveDiscursiveAnswer = null;

    this.showRealize = false;
  }

  ionViewDidEnter() {
    this.getDetailsSurvey();
    this.userSubscription = this.store.select('userState').subscribe(userState => {
      if (userState.user != null) {
        this.userId = userState.user.id;
      }
    });

    setTimeout(() => {
      if (this.selectedItem.acceptedTerm) this.slides.slideTo(2, 0);

      if (this.selectedItem.isDemographicConcluded) this.slides.slideTo(4, 0);
    }, 1000);

    this.paginationNextVisible = true;
    this.cd.markForCheck();
  }

  private getDetailsSurvey() {
    this.setResultSearch();
    this.setAllPerguntas();
    if (this.selectedItem.pesquisa.pesquisaDemografica)
      this.setResultDemographicSearch(this.selectedItem);
  }

  private getResultSearch(mySurvey: any) {
    return this.surveyService
      .listResultsByUserIdAndAppliedSurvey(mySurvey.userId, mySurvey.applySurveyId);
  }

  private setResultDemographicSearch(mySurvey: any) {
    return this.surveyService.loadDemographicAnswers(mySurvey.pesquisa.pesquisaDemografica.id, mySurvey.userId)
      .subscribe(resultadosPorPergunta => {
        resultadosPorPergunta.forEach((resultado) => {
          this.demographicQuestions.forEach((pergunta) => {
            if (pergunta.id == resultado.perguntaDemograficaId) {
              pergunta.resultadoId = resultado.id;
              pergunta.respostaId = resultado.respostaDemograficaId;
              pergunta.pesquisaId = mySurvey.pesquisa.id;
              pergunta.respostaSelecionada = resultado.respostaDemograficaId;
              this.answerDemographicSurvey(pergunta, resultado.respostaDemograficaId);
            }
          })
        });
      });
  }

  private setResultSearch() {
    return this.getResultSearch(this.selectedItem)
      .subscribe(resultadosPesquisa => {
        _.forEach(resultadosPesquisa, (resultado) => {
          _.map(this.selectedItem.pesquisa.dimensoes, (dimensao) => {
            _.map(dimensao.perguntas, (pergunta) => {
              if (resultado.perguntaId == pergunta.id) {
                pergunta.respostaSelecionada = resultado.respostaId;
                pergunta.resultadoId = resultado.id;
                pergunta.respostaId = resultado.respostaId;
                pergunta.resposta = resultado.resposta;
              }
              return pergunta;
            })
            return dimensao;
          })
        });
      });
  }

  private setAllPerguntas() {
    this.surveyQuestions = _.reduce(this.selectedItem.pesquisa.dimensoes, (perguntas, dimensao) => {
      return perguntas.concat(dimensao.perguntas.map(
        (pergunta) => { pergunta.dimensaoId = dimensao.id; return pergunta; }
      ))
    }, [])

    this.surveyQuestions = ((this.selectedItem.pesquisa.shuffleQuestions) ?
      this.shufflerQuestions(this.surveyQuestions) : this.surveyQuestions).
      map(function (item, index) { item.index = (index + 1); return item; });

    this.showRealize = true;
  }

  private shufflerQuestions(surveyQuestions: any) {
    return _.shuffle(this.surveyService.getwithoutDiscursiveQuestions(surveyQuestions))
      .concat(this.surveyService.getDiscursiveQuestions(surveyQuestions));
  }

  ionViewWillLeave() {
    if (this.userSubscription != null) { this.userSubscription.unsubscribe() };
    if (this.surveySubscription != null) { this.surveySubscription.unsubscribe() };
  }

  sortAnswers() {
    const sortFn = (n1: any, n2: any): number => {
      if (n1.sequencia == null || n2.sequencia == null) {
        return n1.id - n2.id;
      } else {
        return n1.sequencia - n2.sequencia;
      }
    };

    this.surveyQuestions = [];
    if (this.selectedItem != null && this.selectedItem.pesquisa != null) {
      if (this.selectedItem.pesquisa.pesquisaDemografica != null) {
        if (this.selectedItem.pesquisa.pesquisaDemografica.perguntas != null) {
          this.demographicQuestions = this.selectedItem.pesquisa.pesquisaDemografica.perguntas.sort(sortFn);
          this.demographicQuestions.forEach(question => {
            if (question.respostas != null) {
              question.respostas = question.respostas.sort(sortFn);
            }
          });
        }
      }
      if (this.selectedItem.pesquisa.dimensoes != null) {
        const sortedDimensions = this.selectedItem.pesquisa.dimensoes.sort(sortFn);
        sortedDimensions.forEach(dimensao => {
          if (dimensao.perguntas != null) {
            dimensao.perguntas.forEach(pergunta => { pergunta.dimensaoId = dimensao.id; });
            this.surveyQuestions.push(...dimensao.perguntas.sort(sortFn));
          }
        });
        this.surveyQuestions.forEach(question => {
          if (question.respostas != null) {
            question.respostas = question.respostas.sort(sortFn);
          }
        });
      }
    }
  }

  controlChange() {
    const type = this.slides._slides[this.slides.getActiveIndex()].getAttribute('data-slideType');
    switch (type) {
      case "pesquisa_titulo":
        if (!this.selectedItem.demograficoConcluido) {
          this.selectedItem.isDemographicConcluded = true;
          this.surveyService.saveSurvey(this.selectedItem).subscribe();
        }
        break;

      case "pergunta":
        this.currentPage = 0;
        this.totalPages = this.surveyQuestions.length;
        this.paginationVisible = true;
        let perguntaId = parseInt(this.slides._slides[this.slides.getActiveIndex()].getAttribute('data-pergunta'), 10);

        let reverseQuestions: Array<SurveyQuestion> = Object.assign([], this.surveyQuestions);
        reverseQuestions = reverseQuestions.reverse();
        this.currentPage = this.totalPages - reverseQuestions.findIndex(x => x.id == perguntaId);
        break;

      default:
        this.paginationVisible = false;
        break;
    }
    this.cd.markForCheck();

    if (this.saveDiscursiveAnswer != null) {
      const answerInfo: SurveyAnswerData = {
        id: this.saveDiscursiveAnswer.respostaId,
        clienteId: this.selectedItem.pesquisa.clienteId,
        usuarioId: this.userId,
        pesquisaId: this.selectedItem.pesquisa.id,
        aplicaPesquisaId: this.selectedItem.applySurveyId,
        dimensaoId: this.saveDiscursiveAnswer.dimensaoId,
        perguntaId: this.saveDiscursiveAnswer.id,
        respostaId: 0,
        resposta: this.saveDiscursiveAnswer.resposta,
        dataHoraAtual: new Date()
      };
      this.store.dispatch(new SurveySaveAnswerAction({ answerInfo: answerInfo, type: this.selectedType }));
      this.saveDiscursiveAnswer = null;
    }
  }

  calculatePaginationNext() {
    this.showHideNextPrevious();
  }

  calculatePaginationPrev() {
    this.showHideNextPrevious();
  }

  showHideNextPrevious() {
    this.paginationNextVisible = this.slides.getActiveIndex() < this.slides.length() - 1;
    this.paginationPreviousVisible = this.slides.getActiveIndex() > 0;
  }

  acceptAccord() {
    this.selectedItem.acceptedTerm = true;
    this.swipeNext = true;
    this.surveyService.saveSurvey(this.selectedItem).subscribe(data => {
      this.slideNext();
    });
  }

  answerDemographicSurvey(item: SurveyQuestion, $event: number) {
    if ($event != null) {
      item.respostaSelecionada = $event;
      this.selectedItem.pesquisa.pesquisaDemografica.perguntas.find(x => x.id == item.id).respostaSelecionada = $event;

      const answerInfo: SurveyDemographicAnswerData = {
        id: item.respostaId,
        usuarioId: this.userId,
        demograficoId: this.selectedItem.pesquisa.pesquisaDemografica.id,
        pesquisaId: this.selectedItem.pesquisa.id,
        perguntaDemograficaId: item.id,
        respostaDemograficaId: $event,
        dataHoraAtual: new Date()
      };
      this.store.dispatch(new SurveySaveDemographicAnswerAction({ answerInfo: answerInfo, type: this.selectedType }));
    }
  }

  answerSurvey(item: SurveyQuestion, $event: any) {
    if (item.tipoResposta != 4) {
      if ($event != null) {
        item.respostaSelecionada = $event;
        this.selectedItem.pesquisa.dimensoes.find(x => x.id == item.dimensaoId).perguntas.find(x => x.id == item.id).respostaSelecionada = $event;
        const answerInfo: SurveyAnswerData = {
          id: item.respostaId,
          clienteId: this.selectedItem.pesquisa.clienteId,
          usuarioId: this.userId,
          pesquisaId: this.selectedItem.pesquisa.id,
          aplicaPesquisaId: this.selectedItem.applySurveyId,
          dimensaoId: item.dimensaoId,
          perguntaId: item.id,
          respostaId: $event,
          resposta: null,
          dataHoraAtual: new Date()
        };
        this.store.dispatch(new SurveySaveAnswerAction({ answerInfo: answerInfo, type: this.selectedType }));
        this.swipeNext = true;
        this.slides.slideNext(500);
      }
    } else {
      if ($event.value)
        this.saveDiscursiveAnswer = item;
    }
  }

  showConfirm() {
    this.selectedItem.termino = this.datePipe.transform(Date.now(), 'dd/MM/yyyy HH:mm');
    this.selectedItem.status = 2;
    this.finish = true;
    this.surveyService.concludeSurvey(this.selectedItem.id).subscribe(data => {
      this.selectedItem.endDate = data.endDate;
      this.presentToast("Pesquisa concluída com sucesso!");
      this.navCtrl.popToRoot()
    });
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  presentPopover(ev) {

    let popover = this.popoverCtrl.create(SurveyMenuPage, {
      page: this,
      slideCount: this.slides.length() - 1,
      demographicDisabled: !this.selectedItem.isDemographicConcluded,
      surveyDisabled: !this.selectedItem.isDemographicConcluded,
      conclusionDisabled: this.surveyQuestions.filter(x => x.respostaId == null).length > 0
    });
    popover.present({
      ev: ev
    });
  }

  goToSlide(slide: number) {
    this.slides.slideTo(slide, 500);
    this.cd.markForCheck();
  }

  slideNext() {
    this.slides.slideNext();
    this.cd.markForCheck();
  }

  slidePrevious() {
    this.slides.slidePrev();
    this.cd.markForCheck();
  }

}


// WEBPACK FOOTER //
// ./src/pages/survey-accomplish/survey-accomplish.ts